<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="fill"
      d="M13.8318 1H1.75339C1.49857 1 1.25419 1.10291 1.07401 1.28608C0.893828 1.46926 0.792603 1.7177 0.792603 1.97674V12.0233C0.792603 12.2823 0.893828 12.5307 1.07401 12.7139C1.25419 12.8971 1.49857 13 1.75339 13H13.8318C14.0866 13 14.331 12.8971 14.5112 12.7139C14.6914 12.5307 14.7926 12.2823 14.7926 12.0233V1.97674C14.7926 1.7177 14.6914 1.46926 14.5112 1.28608C14.331 1.10291 14.0866 1 13.8318 1ZM1.61613 12.0233V1.97674C1.61613 1.93974 1.63059 1.90425 1.65633 1.87808C1.68207 1.85191 1.71698 1.83721 1.75339 1.83721H4.63574V12.1628H1.75339C1.71698 12.1628 1.68207 12.1481 1.65633 12.1219C1.63059 12.0958 1.61613 12.0603 1.61613 12.0233ZM13.9691 12.0233C13.9691 12.0603 13.9546 12.0958 13.9289 12.1219C13.9031 12.1481 13.8682 12.1628 13.8318 12.1628H5.45927V1.83721H13.8318C13.8682 1.83721 13.9031 1.85191 13.9289 1.87808C13.9546 1.90425 13.9691 1.93974 13.9691 1.97674V12.0233Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SidebarIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
